import React, { useEffect, useState } from "react";
import BusinessProfile from "./BusinessProfile";
import BusinessCategories from "./BusinessCategories";
import BusinessDescribe from "./BusinessDescribe";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { BUILD_PROFILE } from "../../mutation/BuildProfile";
import { hasuraClient, nestClient } from "../../apolloClient";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { CREATE_CLUB } from "../../mutation/createClub";
import { UPDATE_USER_ROLE } from "../../mutation/updateUserRole";
import { REFRESH_TOKEN } from "../../mutation/refreshToken";
import { UPADTE_USER } from "../../mutation/updateUser";
import { VIEW_ROLE } from "../../query/ViewRole";

const BuildProfileMain = () => {
  const history = useHistory();
  const [BuildProfile] = useMutation(BUILD_PROFILE, {
    client: hasuraClient,
  });

  const [createClub] = useMutation(CREATE_CLUB, {
    client: hasuraClient,
  });

  const [updateUserRole] = useMutation(UPDATE_USER_ROLE, {
    client: hasuraClient,
  });
  const [refreshTokenM] = useMutation(REFRESH_TOKEN, {
    client: nestClient,
  });

  const [updateUser] = useMutation(UPADTE_USER, {
    client: hasuraClient,
  });
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  const [apiError, setApiError] = useState();
  const [step2Data, setStep2Data] = useState();
  const [profileType, setProfileType] = useState("local_business");
  const [location_text, setLocation_text] = useState(null);
  const [cordinate, setCordinate] = useState(null);

  const { data: userData } = useQuery(VIEW_PROFILE, {
    client: hasuraClient,
  });

  const [data, setData] = useState({
    abn: "",
    description: "",
    name: "",
    mobile: "",
  });

  useEffect(() => {
    if (userRole?.users[0].role === "business") {
      if (userData) {
        setData({
          abn: userData?.users[0]?.business_profile?.abn
            ? userData?.users[0]?.business_profile?.abn
            : "",
          description: userData?.users[0]?.business_profile?.description
            ? userData?.users[0]?.business_profile?.description
            : "",
          name: userData?.users[0]?.business_profile?.name
            ? userData?.users[0]?.business_profile?.name
            : "",
          mobile: userData?.users[0]?.business_profile?.mobile_number
            ? userData?.users[0]?.business_profile?.mobile_number
            : "",
        });
        setLocation_text(userData?.users[0]?.business_profile?.location_text);
        setCordinate(
          userData?.users[0]?.business_profile?.location?.coordinates
        );
      }
    } else {
      if (userData) {
        setData({
          abn: userData?.users[0]?.club_profile?.abn
            ? userData?.users[0]?.club_profile?.abn
            : "",
          description: userData?.users[0]?.club_profile?.description
            ? userData?.users[0]?.club_profile?.description
            : "",
          name: userData?.users[0]?.club_profile?.name
            ? userData?.users[0]?.club_profile?.name
            : "",
        });
        setLocation_text(userData?.users[0]?.club_profile?.location_text);
        setCordinate(userData?.users[0]?.club_profile?.location?.coordinates);
      }
    }
  }, [userData]);

  const [currentStep, setCurrentStep] = useState(0);

  const makeRequest = (formData) => {
    if (profileType === "club") {
      updateUserRole({
        variables: {
          role: "club",
          userId: localStorage.getItem("user_id"),
        },
      })
        .then(() => {
          createClub({
            variables: {
              data: {
                abn: formData.abn,
                location_text: location_text,
                location: {
                  type: "Point",
                  coordinates: cordinate,
                },
                description: formData.description,
                name: formData.name,
                categories: formData.categories,
              },
            },
          })
            .then(() => {
              refreshTokenM({
                variables: {
                  refreshToken: localStorage.getItem("refresh_token"),
                },
              })
                .then((response) => {
                  const { accessToken, refreshToken } =
                    response?.data?.userRefreshToken;
                  localStorage.setItem("jwt_token", accessToken);
                  localStorage.setItem("refresh_token", refreshToken);

                  localStorage.setItem(
                    "user_id",
                    response?.data?.userRefreshToken?.data?.userId
                  );
                  if (response?.data?.userRefreshToken?.data?.profileId) {
                    localStorage.setItem(
                      "profile_id",
                      response?.data?.userRefreshToken?.data?.profileId
                    );
                  }
                  updateUser({
                    variables: {
                      userId: localStorage.getItem("user_id"),
                      is_profile_setup: true,
                    },
                  })
                    .then(() => {
                      localStorage.setItem("is_profile_setup", true);
                      history.push("/build-profile-success");
                    })
                    .catch(() => {});
                })
                .catch(() => {});
            })
            .catch(() => {});
        })
        .catch(() => {});
    } else {
      BuildProfile({
        variables: {
          data: {
            abn: formData.abn,
            location_text: location_text,
            location: {
              type: "Point",
              coordinates: cordinate,
            },
            description: formData.description,
            name: formData.name,
            categories: formData.categories,
            mobile_number: formData.mobile,
          },
        },
      })
        .then((response) => {
          localStorage.setItem(
            "profile_id",
            response?.data?.insert_business_profile_one?.id
          );
          updateUser({
            variables: {
              userId: localStorage.getItem("user_id"),
              is_profile_setup: true,
            },
          })
            .then(() => {
              localStorage.setItem("is_profile_setup", true);
              history.push("/build-profile-success");
            })
            .catch(() => {});
        })
        .catch((e) => {
          const errors = e.graphQLErrors;
          if (errors[0] && errors[0].message) {
            setApiError(errors[0].message);
          }
        });
    }
  };

  const handlePreviousStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleNextStep = (newData, final = false) => {
    setData((prev) => ({ ...prev, ...newData }));

    let finalData = { ...data, ...newData };

    if (final) {
      makeRequest(finalData);
      return;
    }

    setCurrentStep((prev) => prev + 1);
  };

  const steps = [
    <BusinessProfile
      next={handleNextStep}
      data={data}
      setLocation_text={setLocation_text}
      setCordinate={setCordinate}
      location_text={location_text}
      cordinate={cordinate}
      setProfileType={setProfileType}
      profileType={profileType}
    />,
    <BusinessCategories
      previous={handlePreviousStep}
      next={handleNextStep}
      data={data}
      setDynamicData={setStep2Data}
      step2Data={step2Data}
    />,
    <BusinessDescribe
      previous={handlePreviousStep}
      next={handleNextStep}
      data={data}
    />,
  ];

  return (
    <div className="businessprofile-main">
      <div className="dots">
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep >= 0 ? "#696AE7" : "#E1E1E1",
            marginRight: "25px",
          }}
        ></div>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep > 0 ? "#696AE7" : "#E1E1E1",
            marginRight: "25px",
          }}
        ></div>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep > 1 ? "#696AE7" : "#E1E1E1",
          }}
        ></div>
      </div>

      {steps[currentStep]}

      {apiError ? <div className="error-message">{apiError}</div> : null}
      {/* <BusinessProfile />
            <BusinessCategories />
            <BusinessDescribe /> */}
    </div>
  );
};

export default BuildProfileMain;
